export default {"src":"/_next/static/media/spinner-wheel.781a77c7.svg","height":140,"width":129,"blurWidth":0,"blurHeight":0};